import { Component } from "react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error) {
    console.error("Tab render error:", error);
  }

  render() {
    if (this.state.failed) {
      return (
        <div className="bg-white rounded-2xl border p-10 text-center space-y-3" data-testid="tab-error-fallback">
          <p className="font-bold text-rose-700">حدث خطأ في عرض هذا القسم</p>
          <button onClick={() => this.setState({ failed: false })}
            className="text-sm text-emerald-800 hover:underline">
            إعادة المحاولة
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
